import styled from '@emotion/styled';

import { FormActions, SignupCheckboxLabel } from '@/components/SignUp/signupStyles';

export const FieldBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${(props) => props.theme.scale.spaceXl};
	width: 100%;
`;

export const TermsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: ${(props) => props.theme.scale.spaceLg};

	@media screen and (max-width: 900px) {
		grid-template-columns: 1fr;
	}
`;

export const AgreementCard = styled.article`
	display: flex;
	flex-direction: column;
	min-height: 0;
	border: 1px solid ${(props) => props.theme.ui.border.default};
	border-radius: ${(props) => props.theme.effects.radiusMd};
	background: ${(props) => props.theme.ui.surface.subtle};
	overflow: hidden;
`;

export const AgreementTitle = styled.h3`
	margin: 0;
	padding: ${(props) => props.theme.scale.spaceMd} ${(props) => props.theme.scale.spaceLg};
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 1.35;
	color: ${(props) => props.theme.ui.text.primary};
	border-bottom: 1px solid ${(props) => props.theme.ui.border.default};
	background: ${(props) => props.theme.ui.surface.page};
`;

export const TermsScroll = styled.div`
	flex: 1;
	min-height: 16rem;
	max-height: 22rem;
	padding: ${(props) => props.theme.scale.spaceMd};
	overflow: auto;
	background: ${(props) => props.theme.ui.surface.page};

	textarea {
		min-height: 14rem;
		height: 100%;
		border-color: transparent;
		background: transparent;
		box-shadow: none;
		resize: none;
		cursor: default;

		&:focus {
			border-color: transparent;
			box-shadow: none;
		}
	}
`;

export const AgreeRow = styled(SignupCheckboxLabel)`
	padding: ${(props) => props.theme.scale.spaceMd} ${(props) => props.theme.scale.spaceLg};
	border-top: 1px solid ${(props) => props.theme.ui.border.default};
	background: ${(props) => props.theme.ui.surface.page};
`;

export const Actions = styled(FormActions)``;
